export default "__VITE_ASSET__f0ab783c__"